import React from 'react';
import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/base-components';
import getLanguageDisplayNames from './getLanguageDisplayNames';

const LanguagePillSelectorWrapper = styled(Box).attrs({
  horizontal: true,
  flow: 4,
})``;

const LanguagePillSelectorButton = styled(Button)`
  padding: 4px 10px;
  height: auto;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.highlights : 'transparent'};
  color: ${({ isActive, theme }) =>
    isActive ? theme.colors.primaryText : theme.colors.secondaryText};
`;

const LanguageDisplay = ({ transcriptOption, detectedLanguages = [] }) => {
  const languages = (getLanguageDisplayNames(detectedLanguages) || []).join(
    ', ',
  );
  const detectionFallback = 'Original';

  const transcriptOptionMap = {
    original: `${languages || detectionFallback}`,
    translated: 'English',
  };

  return <Text>{transcriptOptionMap[transcriptOption]}</Text>;
};

const LanguagePillSelector = ({
  selectedLanguage = 'original',
  detectedLanguages = [],
  onChange = () => {},
}) => {
  return (
    <LanguagePillSelectorWrapper marginBottom={1}>
      {['translated', 'original'].map(transcriptOption => (
        <LanguagePillSelectorButton
          size="small"
          key={transcriptOption}
          isActive={selectedLanguage === transcriptOption}
          onClick={() => onChange(transcriptOption)}
          noMargin
          btnType="secondary"
          dataName={`language-option-${transcriptOption}`}
        >
          <LanguageDisplay
            transcriptOption={transcriptOption}
            detectedLanguages={detectedLanguages}
          />
        </LanguagePillSelectorButton>
      ))}
    </LanguagePillSelectorWrapper>
  );
};

export default LanguagePillSelector;
